import { useState } from 'react';

import { CSS } from '@project44/manifest-ds';

export function usePanelAnimation() {
  const [style, setStyle] = useState<CSS>({
    transform: 'translateX(calc(652px + 4rem))',
    transitionProperty: 'transform',
    transitionTimingFunction: 'ease',
    transitionDuration: '300ms',
  });

  const slideIn = () =>
    setStyle({
      ...style,
      transform: 'translateX(0)',
    });

  const slideOut = () =>
    setStyle({
      ...style,
      transform: 'translateX(calc(652px + 4rem))',
    });

  return {
    slideIn,
    slideOut,
    style,
  };
}

export function useTableTransition() {
  const [style, setStyle] = useState<CSS>({
    transitionProperty: 'max-width',
    transitionDuration: '300ms',
    transitionTimingFunction: 'ease',
    maxWidth: '100%',
  });

  const slideIn = () =>
    setStyle({
      ...style,
      maxWidth: 'calc(100% - 652px - 0.5rem)',
    });

  const slideOut = () =>
    setStyle({
      ...style,
      maxWidth: '100%',
    });

  return {
    slideIn,
    slideOut,
    style,
  };
}
